// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"392":"e9730b4d","2589":"d6fdf0fb","4097":"1388905f","8921":"4432e7e9","9110":"a365e324"}[chunkId] + ".css";
};